import { formatDateLocal } from "../../../../../../lib/script";
import PoliceReportBox from "../PoliceReportBox";
import PoliceReportVerificationBox from "../PoliceReportVerificationBox";

export default function IncidentDetails({classes, activeCase, isProcessed}) {

    const numberOfOccupants = activeCase.police_report?.moonbird_data?.vehicle?.occupants?.length ? activeCase.police_report?.moonbird_data?.vehicle?.occupants?.length  : 1
    return <div className={classes.group}>
        <h3>Incident Details</h3>

        <PoliceReportVerificationBox isProcessed={isProcessed} isEditable={false} fieldType={'date'} caseId={activeCase.case.id} classes={classes} label={'Incident Date'} isDate={activeCase.police_report?.incident_date} reportValue={formatDateLocal(activeCase.police_report?.moonbird_data?.incident?.date)} eCMValue={formatDateLocal(activeCase.case?.incident_date)} identifier={{folder: 'case',type: 'case', field: 'incident_date', type_id: null}}/>

        <PoliceReportBox isProcessed={isProcessed} caseId={activeCase.case.id} classes={classes} label={'Total # of vehicles'} reportValue={activeCase.police_report?.moonbird_data?.incident?.number_of_vehicles} eCMValue={null} />


        <PoliceReportVerificationBox isProcessed={isProcessed} caseId={activeCase.case.id} classes={classes} label={'Total # of occupants in Patient Vehicle'} reportValue={numberOfOccupants} eCMValue={activeCase.additional?.people_involved} identifier={{folder: 'additional', type: 'case_additional', field: 'people_involved', type_id: null}}/>

            
    </div>
}
